import boxScanController from './boxScanController';
import drugScanController from './drugScanController';
import scanViewController from './scanViewController';
import { barcodeAndOfflineLookup } from '../utils/barcodeLookup';
import models from '../model/models';
import toasts from '../utils/toasts';
import offlineScanController from './offlineScanController';
import GeneralCheckPopup from "../components/popups/generalCheckPopup/GeneralCheckPopup";
import OptionsPopup from "../components/popups/optionsPopup/OptionsPopup";
import mainAPI from "../api/MainAPI";

let ScanController = function () {
	this.callIds = [];
	this.start = () => {
		models.drug_type.refreshData();
		this.showScanner();
	};
	this.showScanner = () => {
		scanViewController.showScanner(
			'Scan a Drug or Box',
			'Place the scan area on the code',
			this._handleScan,
			null,
			true,
			null,
			{hideRootDelayMs:300}
		);
	};

	this._handleScan = async (text, inputManually) => {
		const callId = Date.now();
		if(text === 'vehicle'){
			scanViewController.hideScanner();
			const res = await mainAPI.general_check.all();
			return window.popupController.show(OptionsPopup, {
				handleSelect: (option, label) => {
					window.popupController.show(GeneralCheckPopup, {generalCheckId:option, name:label})
				},
				option1: { label: res[0].name, value: res[0].id },
				option2: { label: res[1].name, value: res[1].id },

			});
		}
		this.offlinePromptTimeoutId = setTimeout(() => this.promptForOfflineMode(text, inputManually, callId), 5000);
		let { drug, box, online } = await barcodeAndOfflineLookup(text);
		this.clearTimeout();
		if (!online) {
			return this.promptForOfflineMode(text, inputManually, callId);
		}
		if (drug) {
			drugScanController.start(drug);
			await drugScanController.foundDrug(drug);
		} else if (box) {
			boxScanController.start();
			await boxScanController.foundBox(box);
		} else {
			drugScanController.start();
			await drugScanController.drugNotFound(text);
		}
	};
	this.clearTimeout = () => {
		let timeoutCleared = false;
		if(this.offlinePromptTimeoutId) {
			clearTimeout(this.offlinePromptTimeoutId);
			timeoutCleared = true;
		}
		this.offlinePromptTimeoutId = null;
		return timeoutCleared;
	};

	this.promptForOfflineMode = (text, inputManually, callId) => {
		if(this.callIds.includes(callId)) return;
		this.callIds.push(callId);
		this.callIds = this.callIds.sort((a, b) => b - a).slice(0, 30);
		return window.f7.dialog.confirm('Would you like to continue offline?', 'It looks like you are offline', () => {
			offlineScanController.start(text, inputManually);
			toasts.show('Going offline');
		});
	};
};

let scanController = new ScanController();
export default scanController;
